import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {InstallationQuote} from '../../../../../../../../../../../quotes/src/app/data/Installation-quote';

@Component({
  selector: 'app-installation-quote-dialog',
  templateUrl: './installation-quote-dialog.component.html',
  styleUrls: ['./installation-quote-dialog.component.scss']
})
export class InstallationQuoteDialogComponent implements OnInit {
  quote: InstallationQuote;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InstallationQuote,
  ) {
    this.quote = this.data
  }

  ngOnInit(): void {
  }

}
